export const TOGGLE_SETTINGS = "TOGGLE_SERVICES_SETTINGS";
export const FILTER_SERVICE = "FILTER_SERVICE";
